import repository from "../Repository";

export default {
  async listbox(screenId) {
    return await repository.post("vul_facilities", {
        headers: {
          s: screenId
        }
      });
  },
  async list(screenId, municip_code) {
    return await repository.post(
      "vul_facility_mst_info",
      {
        municip_code
      },
      {
        headers: {
          s: screenId
        }
      }
    );
  },
  async create(screenId, payload) {
    return await repository.post("vul_facility_mst_ope", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async update(screenId, payload) {
    return await repository.patch(`vul_facility_mst_ope`, payload, {
      headers: {
        s: screenId
      }
    });
  },
  async delete(screenId, payload) {
    return await repository.patch("vul_facility_mst_ope/delete", payload, {
      headers: {
        s: screenId
      }
    });
  }
};
